import { dataLightning } from 'dls-icons-data'
import { createIcon } from '../common'

const IconLightning = /*#__PURE__*/createIcon(dataLightning)
export default IconLightning
